(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-store-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-store-tour')) customElements.define('lf-store-tour',class extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  const dialog=this.querySelector('dialog'), opener=this.querySelector('[data-tour-open]');
  if(!dialog||!opener)return;
  const slides=[...dialog.querySelectorAll('figure')];let index=0;
  const show=(n)=>{index=Math.max(0,Math.min(slides.length-1,n));slides.forEach((slide,i)=>{slide.hidden=i!==index;if(i===index){const img=slide.querySelector('img');if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}}});dialog.querySelector('[data-tour-count]').textContent=`${index+1} / ${slides.length}`;dialog.querySelector('[data-tour-prev]').disabled=index===0;dialog.querySelector('[data-tour-next]').disabled=index===slides.length-1;};
  opener.addEventListener('click',()=>{show(0);dialog.showModal();},{signal});
  dialog.querySelector('[data-tour-close]').addEventListener('click',()=>dialog.close(),{signal});
  dialog.querySelector('[data-tour-prev]').addEventListener('click',()=>show(index-1),{signal});
  dialog.querySelector('[data-tour-next]').addEventListener('click',()=>show(index+1),{signal});
  dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}},{signal});
  let touchX=null;dialog.addEventListener('touchstart',e=>{touchX=e.touches[0].clientX;},{signal,passive:true});dialog.addEventListener('touchend',e=>{if(touchX!==null){const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>60)show(index+(dx<0?1:-1));touchX=null;}},{signal,passive:true});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},{signal});
  dialog.addEventListener('close',()=>opener.focus({preventScroll:true}),{signal});
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
